var config = {
  network: {
    layer1: 'placeholder'
  },
  logLevel: 'debug'
};

export { config };
//# sourceMappingURL=config.esm.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/@stacks/connect/node_modules/@stacks/transactions/node_modules/@stacks/network/node_modules/@stacks/common/dist/config.esm.js
// module id = gyys
// module chunks = 6